import * as yup from 'yup';

export const createCaseSchema = yup.object().shape({
  subject: yup.string(),
  message: yup.string(),
});
